import { FC } from 'react'
import styles from './logotype.module.scss'
import LogotypeIcon from '@/components/icons/LogotypeIcon'
import classNames from '@/utils/helpers/class-names.helper'
import Image from 'next/image'

type LogotypeProps = {
  className?: string
  classNameText?: string
  width?: number
  height?: number
  subText?: string
  capa?: boolean
}

const Logotype: FC<LogotypeProps> = ({
  className,
  classNameText = styles.text,
  width = 104,
  height = 32,
  subText,
  capa,
}) => {
  return (
    <div className={classNames(className, styles.logotype)}>
      <LogotypeIcon textClassName={classNameText} width={width} height={height} />
      {subText && (
        <div className={styles.subText}>
          {subText}
          {capa && (
            <Image
              className={styles.capa}
              width={16}
              height={16}
              src="/img/icons/capa.svg"
              alt="иконка праздничного колпака"
              title="иконка праздничного колпака"
            />
          )}
        </div>
      )}
    </div>
  )
}

export default Logotype
